import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=80d2409a&scoped=true&"
import script from "./NavigationComponent.vue?vue&type=script&lang=ts&"
export * from "./NavigationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d2409a",
  null
  
)

export default component.exports